import { Mail, Send } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { Button, Card, Field, Input } from "./ui";

export function WeeklyReportCard({ cfg, setCfg }: { cfg: any; setCfg: (c: any) => void }) {
  const [h, setH] = useState<any>(null);
  const [test, setTest] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/weekly-report/history").then((r) => setH(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const send = async (to?: string) => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/weekly-report/send-now", to ? { to } : {});
      if (data.errors?.length) toast.error(data.errors.join("; ")); else toast.success(`Laporan terkirim ke ${data.sent.join(", ")}`);
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Card title="Laporan Mingguan Otomatis" subtitle="Dikirim setiap Senin 06:00 WIB: KPI, penerimaan minggu lalu, tunggakan, NPL, simpanan, sorotan, dan tautan PDF Laporan Eksekutif" testId="weekly-report-card">
      <div className="space-y-3">
        <Field label="Email penerima" hint="Pisahkan dengan koma untuk lebih dari satu. Simpan konfigurasi setelah mengubah."><Input data-testid="config-weekly-emails" value={cfg.weekly_report_emails || ""} onChange={(e) => setCfg({ ...cfg, weekly_report_emails: e.target.value })} placeholder="nama@email.com, kepala@koperasi.id" /></Field>
        {h && !h.email_ready && <p className="text-xs text-red-600" data-testid="weekly-email-off">Layanan email belum aktif — hubungi administrator sistem.</p>}
        <div className="flex flex-wrap items-end gap-2">
          <Button size="sm" disabled={busy || !h?.recipients?.length} onClick={() => send()} data-testid="weekly-send-now"><Send className="h-4 w-4" /> Kirim sekarang ke penerima tersimpan</Button>
          <div className="flex items-end gap-2 ml-auto"><Input data-testid="weekly-test-email" className="w-56" placeholder="email uji" value={test} onChange={(e) => setTest(e.target.value)} /><Button size="sm" variant="outline" disabled={busy || !test.includes("@")} onClick={() => send(test)} data-testid="weekly-send-test"><Mail className="h-4 w-4" /> Kirim uji</Button></div>
        </div>
        {h?.rows?.length > 0 && (
          <div className="text-xs space-y-1" data-testid="weekly-history">
            <p className="font-semibold uppercase tracking-wide text-muted-foreground">Riwayat pengiriman</p>
            {h.rows.map((r: any, i: number) => <p key={i} className="num">{fmtDateTime(r.at)} · {r.trigger === "cron" ? "otomatis" : r.trigger.replace("manual:", "manual oleh ")} · terkirim {r.sent.length}{r.errors.length ? <span className="text-red-600"> · gagal: {r.errors.join("; ")}</span> : ""}</p>)}
          </div>
        )}
      </div>
    </Card>
  );
}
